import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { startCase } from "lodash";
import CuoButton from "@/app/admin/_common/CuoButton";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/app/admin/_common/ui/dropdown-menu";
import { SHOWTYPES } from "@/app/_utils/constants";
import { PlusCircle, Drama, Sparkles } from "lucide-react";
import { useIsMobile } from "@/app/admin/_hooks/useIsMobile";

export default function ShowsHeader() {
  const navigate = useNavigate();
  const isMobile = useIsMobile();

  return (
    <div className="flex items-center gap-2">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <CuoButton
            variant={isMobile ? "outline" : "default"}
            label={<span className="hidden sm:inline">New show</span>}
            icon={<PlusCircle className="size-3.5 shrink-0" size={14} />}
            className="px-2 sm:px-3"
            aria-label="New show"
          />
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="w-40">
          {SHOWTYPES.map((type) => (
            <DropdownMenuItem
              key={type}
              onClick={() =>
                navigate(
                  `/admin/shows/newshow?startDate=${dayjs().format("YYYY-MM-DD")}&type=${type}`
                )
              }
            >
              {type === "comedy" ? (
                <Drama className="mr-2 size-4 text-primary" />
              ) : (
                <Sparkles className="mr-2 size-4 text-primary" />
              )}
              {startCase(type)}
            </DropdownMenuItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
